<h3 mat-dialog-title style="padding-top: 10px;">{{translateArr.bp1}}</h3>
<p>{{translateArr.bp2}}</p>
<div class="d-flex flex-row-reverse"  style="padding-top: 10px;">
    <button class="login-button btn btn-lg" mat-button mat-dialog-close (click)="OK()">{{translateArr.bp3}}</button>
</div>
